<template>
  <div class="pa-6">
    <PremiumPage
      title="Bank Details & Cashfree Settings"
      subtitle="Manage your society's bank account and payment gateway settings"
      content-class="pa-6"
    >
      <v-alert
          type="info"
          border="left"
          colored-border
          color="var(--brand)"
          class="mb-6"
          elevation="0"
          style="background-color: var(--surface2) !important; color: var(--tx) !important;"
        >
          Setting up your bank details allows members to pay their bills directly through the mobile app using Cashfree Easy Split. Funds will be directly settled to this bank account.
        </v-alert>

        <v-form ref="bankForm" v-if="dataLoaded">
          <v-row dense>
            <v-col cols="12">
              <PremiumInput
                v-model="bank.bank_beneficiary_name"
                label="Beneficiary Name"
                placeholder="Enter exact name on bank account"
                icon="mdi-account-cash-outline"
                v-validate="'required'"
                name="bank_beneficiary_name"
                :error="errors.first('bank_beneficiary_name')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <PremiumInput
                v-model="bank.bank_account_number"
                label="Account Number"
                placeholder="Enter bank account number"
                icon="mdi-bank-outline"
                v-validate="'required|numeric'"
                name="bank_account_number"
                :error="errors.first('bank_account_number')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <PremiumInput
                v-model="bank.bank_ifsc"
                label="IFSC Code"
                placeholder="Enter 11-character IFSC code"
                icon="mdi-barcode"
                v-validate="'required|length:11'"
                name="bank_ifsc"
                :error="errors.first('bank_ifsc')"
              />
            </v-col>
            <v-col cols="12" md="4">
              <PremiumInput
                v-model="bank.kyc_account_type"
                label="Account Type"
                placeholder="e.g., Business Entity or Individual"
                icon="mdi-briefcase-outline"
                v-validate="'required'"
                name="kyc_account_type"
                :error="errors.first('kyc_account_type')"
              />
            </v-col>
           
            <v-col cols="12" md="4">
              <PremiumInput
                v-model="bank.kyc_pan"
                label="PAN Number"
                placeholder="Enter 10-character PAN"
                icon="mdi-card-account-details-outline"
                v-validate="'required|length:10'"
                name="kyc_pan"
                :error="errors.first('kyc_pan')"
              />
            </v-col>
          </v-row>
        </v-form>

        <div v-if="bank.vendor_status" class="mt-4">
          <v-chip
            :color="bank.vendor_status === 'active' ? 'green' : 'orange'"
            text-color="white"
            small
            class="font-weight-bold"
          >
            Vendor Status: {{ bank.vendor_status.toUpperCase() }}
          </v-chip>
          <span class="caption text-muted ml-2" v-if="bank.cashfree_vendor_id">
            Vendor ID: {{ bank.cashfree_vendor_id }}
          </span>
        </div>

      <template #footer>
        <v-btn
          depressed
          class="btn-premium-primary"
          @click="saveBankDetails"
          :loading="loading"
        >
          Save Details
        </v-btn>
      </template>
    </PremiumPage>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import PremiumInput from "../../common/PremiumInput.vue";
import PremiumPage from "../../common/PremiumPage.vue";

export default {
  name: "SocietyAdminBankDetails",

  components: { PremiumInput, PremiumPage },

  data() {
    return {
      loading: false,
      dataLoaded: false,
      bank: {
        bank_beneficiary_name: "",
        bank_account_number: "",
        bank_ifsc: "",
        kyc_account_type: "",
        kyc_pan: "",
        cashfree_vendor_id: "",
        vendor_status: ""
      }
    };
  },

  created() {
    this.getBankDetails();
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getBankDetails() {
      let _self = this;
      _self.$axios.get("/societyadmin/bank-details").then((response) => {
        let data = response.data;
        if (data.status && data.data) {
          _self.bank = data.data;
        }
        _self.dataLoaded = true;
      }).catch(() => {
        _self.dataLoaded = true;
      });
    },

    saveBankDetails() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios
            .post("/societyadmin/bank-details", {
              bank_beneficiary_name: _self.bank.bank_beneficiary_name,
              bank_account_number: _self.bank.bank_account_number,
              bank_ifsc: _self.bank.bank_ifsc,
              kyc_account_type: _self.bank.kyc_account_type,
              kyc_pan: _self.bank.kyc_pan
            })
            .then((response) => {
              let data = response.data;
              _self.loading = false;

              if (data.status) {
                _self.bank = data.data;
                _self.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 3000,
                });
              } else {
                _self.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "red accent-3",
                  timeout: 3000,
                });
              }
            })
            .catch((error) => {
              _self.loading = false;
              _self.setAlert({
                showAlert: true,
                message: error.response?.data?.message || 'Failed to save bank details.',
                variant: "red accent-3",
                timeout: 3000,
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.text-muted {
  color: var(--tx3);
}
</style>
